import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { getUserId } from "./utils/auth";
import moment from "moment";
import { getTimeStamp, setTimeStamp } from "./utils/general";
window._ = require("lodash");
import "./views/layout/mixin/Global.js";
import Export from "./expense";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		attributes: {},
		pendingExpense: {},
		projects: {},
		activeExpense: {},
		showAsideMenu: true,
		appVersionNumber: process.env.VUE_APP_VERSION,
		team: null
	},
	actions: {
		loadAttribute({ commit }) {
			return new Promise(resolve => {
				let user_id = getUserId();
				axios
					.get("/attributes?user_id=" + user_id, { crossdomain: true })
					.then(result => {
						const attributes = result.data;
						commit("SET_ATTRIBUTE", attributes);
						resolve("success");
					});
			});
		},
		async loadPendingExpense({ commit }) {
			let user_id = getUserId();
			await axios
				.get("/receipts/pending?user_id=" + user_id, { crossdomain: true })
				.then(({ data }) => {
					commit("SET_PENDINGEXPENSE", data || []);
				});
		},
		async loadActiveExpense({ commit }) {
			let user_id = getUserId();
			let apiEndPoint = "";
			if (!this.state.team) {
				apiEndPoint = `/receipts?user_id=${user_id}`;
			} else {
				apiEndPoint = `/receipts?user_id=${user_id}&&team_role=${this.state.team.role}&&team_id=${this.state.team.team_id}`;
			}
			await axios
				.get(apiEndPoint, {
					crossdomain: true
				})

				.then(
					({ data }) => {
						// link up all the category data
						data.receipts.forEach(receipt => {
							receipt.icon = Export.getCategoryIcon(receipt["CategoryName"]);
						});
						commit("SET_ACTIVEEXPENSE", data.receipts || []);
					},
					e => {
						console.log(e);
					}
				);
		},
		async removeExpense({ commit }, { id }) {
			commit("REMOVE_EXPENSE", id);
		},
		async loadPendingTimestamp({ commit }) {
			let user_id = getUserId();
			let timestamp = getTimeStamp();
			setTimeStamp(moment().unix());
			const url =
				"/receipts?user_id=" + user_id + "&last_timestamp=" + timestamp;
			await axios.get(url, { crossdomain: true }).then(({ data }) => {
				const self = this;
				if (data.receipts.length > 0) {
					var pending_expenses = self.state.pendingExpense.receipts;
					var receiptsToAdd = [];
					_.each(data.receipts, function(receipt) {
						if (receipt["ProjectName"] !== undefined) {
							let find = _.find(pending_expenses, {
								ReceiptId: receipt.ReceiptId
							});
							if (find !== undefined) {
								pending_expenses = _.reject(pending_expenses, {
									ReceiptId: receipt.ReceiptId
								});
								receipt.icon = Export.getCategoryIcon(receipt["CategoryName"]);
								receiptsToAdd.push(receipt);
							}
						}
					});

					commit("UPDATE_PENDINGEXPENSE", {
						total: pending_expenses.length,
						receipts: pending_expenses
					});
					commit("UPDATE_ACTIVEEXPENSE", receiptsToAdd);
				}
			});
		},
		updateExpense({ commit }, { expense }) {
			commit("UPDATE_EXPENSE", expense);
		},
		async exportExpense({ commit }, param) {
			try {
				const userId = getUserId();
				param.user_id = userId;
				const url = "/export";
				const { data } = await axios.post(url, param);
				commit("EXPORT_SUCCESSFUL", data);
			} catch (error) {
				return error;
			}
		},
		clickHamburger({ commit }, { value }) {
			commit("SHOW_ASIDE_MENU", value);
		}
	},
	mutations: {
		SET_ATTRIBUTE(state, attributes) {
			state.attributes = attributes;
			state.team = attributes.team;
		},
		SET_PENDINGEXPENSE(state, pendingExpense) {
			state.pendingExpense = pendingExpense;
		},
		SET_ACTIVEEXPENSE(state, activeExpense) {
			state.activeExpense = activeExpense;
		},
		UPDATE_PROJECT(state, projects) {
			state.attributes["project"] = projects;
		},
		UPDATE_PENDINGEXPENSE(state, expense) {
			state.pendingExpense = expense;
		},
		UPDATE_ACTIVEEXPENSE(state, expenses) {
			state.activeExpense = [...state.activeExpense, ...expenses];
		},
		REMOVE_EXPENSE(state, id) {
			const newList = _.reject(state.activeExpense, { ReceiptId: id });
			state.activeExpense = newList;
		},
		UPDATE_EXPENSE(state, expense) {
			var updatedExpenses = _.reject(state.activeExpense, {
				ReceiptId: expense.ReceiptId
			});
			updatedExpenses.push(expense);
			state.activeExpense = updatedExpenses;
		},
		EXPORT_SUCCESSFUL(state, response) {
			state.isExportSuccessful = response;
		},
		SHOW_ASIDE_MENU(state, value) {
			state.showAsideMenu = value;
		}
	}
});
